import FooterPrimaryLinks from './FooterPrimaryLinks';

export default FooterPrimaryLinks;
